import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LanguageService {

  private lang = localStorage.getItem('userLang') || 'nl';
  translateLanguge: BehaviorSubject<string> = new BehaviorSubject<string>(this.lang);
  selectedLanguageSubscriber;

  constructor() {}
}
